// extracted by mini-css-extract-plugin
export default {"columnHeader":"IssueColumnHeader_columnHeader__JoANZ","sticky":"IssueColumnHeader_sticky__IiyQD"};